<template>
  <div class="wrapper mt-2">
    <template v-if="$store.getters.getUserHasFeature('customers')">
      <div class="card is-smallshadow width-narrow mx-auto">
        <div class="card-body pt-3">
          <h2 class="heading-big mb-3">
            <template v-if="isEdit">{{ $t('customerFormWrapper.editCustomer') }}</template>
            <template v-else>{{ $t('customerFormWrapper.addNewCustomer') }}</template>
          </h2>
          <customer-form
            :readonly="false"
            :addNewCustomer="true" />
        </div>
      </div>
    </template>
    <f-alert
      v-else
      visible
      class="my-5"
      theme="inactive">
      <span>
      {{ $t('user.currentPackageDoesNotIncludeAccessToSection') }}
      </span>
    </f-alert>
  </div>
</template>

<script>
import CustomerForm from '@/views/forms/customer/CustomerForm.vue';

export default {
  name: 'customer-form-wrapper',
  components: {
    'customer-form': CustomerForm
  },
  computed: {
    isEdit () {
      return !!this.$route.params.id;
    }
  },
}
</script>
